/** Count-based collage layouts for Visual Project Gallery cards.
 * Layout follows the number of cover media (1–4) per
 * VISTOERA_CONTENT_PROJECT_DYNAMIC_COVER_FROM_GENERATED_ARTIFACTS_V1 §7. */

export interface CollageSlot {
  className: string
}

export interface CollageLayout {
  id: string
  slots: CollageSlot[]
}

export function layoutForCount(count: number): CollageLayout {
  if (count <= 1) {
    return {
      id: 'one',
      slots: [{ className: 'cpg-slot cpg-slot--solo' }],
    }
  }
  if (count === 2) {
    return {
      id: 'two',
      slots: [
        { className: 'cpg-slot cpg-slot--primary' },
        { className: 'cpg-slot cpg-slot--secondary' },
      ],
    }
  }
  if (count === 3) {
    return {
      id: 'three',
      slots: [
        { className: 'cpg-slot cpg-slot--primary' },
        { className: 'cpg-slot cpg-slot--secondary-top' },
        { className: 'cpg-slot cpg-slot--secondary-bottom' },
      ],
    }
  }
  return {
    id: 'four',
    slots: [
      { className: 'cpg-slot cpg-slot--quad-a' },
      { className: 'cpg-slot cpg-slot--quad-b' },
      { className: 'cpg-slot cpg-slot--quad-c' },
      { className: 'cpg-slot cpg-slot--quad-d' },
    ],
  }
}
